import { Component, ElementRef, Input, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { PatientService } from '../../../services/patient.service';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { refreshService } from '../../../services/refersh.service';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from '@angular/router';
import { NewProfileComponent } from '../new-profile/new-profile.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
let dayWeek = [{ name: "Days", selected: true, value: "" }, { name: "Weeks", selected: false, value: "" }, { name: "Month", selected: false, value: "" }]
@Component({
  selector: 'app-patient-referral',
  templateUrl: './patient-referral.component.html',
  styleUrls: ['./patient-referral.component.css']
})
export class PatientReferralComponent implements OnInit {
  @ViewChild("addReferralModal") addReferralModal!: ElementRef;
  @ViewChild("viewReferralModal") viewReferralModal!: TemplateRef<any>;
  @ViewChild("viewDocumentsModal") viewDocumentsModal!: TemplateRef<any>;
  dayWeeksArray: any = [];
  selectedWhenToTake = ''
  daysWeeks: any = ''
  isReferralLoading: boolean = false;
  @Input() doctorObj: any
  @Input() patientResponse: any
  allReferrals: any = [];
  displayedColumns: string[] = [
    'sr no',
    'uploaded by',
    'date',
    'document type',
    'preview'
  ];
  documentPdfURL: any;
  showErrors: boolean = false;
  @Input() appointmentArr: any
  gender: any = ''
  genderHe = ""
  presentComplaints: any;
  medCondition: any;
  allReferralsDS!: MatTableDataSource<any>; // ✅ table datasource
  duration: any
  selectedDate: any;
  patientFullName: any = '';
  alreadyCreated: boolean = false;
  patientAge: any = '';
  durationnn: any;
  templateText: any = ''
  docNamee = '';
  docName: any;
  notesArr: any = [];
  docEmail: any = '';
  pramPatientId: any;
  docMobNumber = '';
  refreelcertiPdfURL: any = '';
  refreelcertisURL: any = ''
  templateName: any = "Speciality";
  selectedTemplate: any = [];
  constructor(public dialog: MatDialog, private modalService: NgbModal, @Optional() private parent: NewProfileComponent, private refreshservice: refreshService, private sanitizer: DomSanitizer, private messageService: MessageService, private patientService: PatientService, private route: ActivatedRoute) {

    this.dayWeeksArray = dayWeek;
  }

  callParentFunction() {
    this.parent?.getAllDoctorPrescriptions(); // ✅ calls parent's function
  }
  ngOnChanges() {
    if (this.appointmentArr?.length) {
      this.getAllReferrals();
    }
  }
  ngOnInit(): void {

    this.route.queryParams.subscribe((params: any) => {
      this.pramPatientId = params.patientId ? params.patientId : null
    })
    // this.callParentFunction()
    console.log("AUG7777", this.appointmentArr)
    // setTimeout(() => {
    //   console.log("this.patientResponse", this.patientResponse);
    // }, 4000);
    this.switchDaysWeeks(0);
    this.daysWeeks = "Days"
    this.gender = this.patientResponse.gender.toLowerCase() === 'male' ? 'M' : "F";
    if (this.gender == 'F') {
      this.genderHe = "She";
    }
    else {
      this.genderHe = 'He';
    }
    var services = JSON.parse(this.doctorObj.services);
    if (services.template_names) {
      this.templateName = 'Speciality';
      this.selectedTemplate = services.template_names;
    }
    else {
      this.selectedTemplate.push('default');
    }
    this.selectedDate = this.reverseDate(new Date());

    if (this.selectedTemplate.length > 0) {
      this.templateName = this.selectedTemplate[0]; // Select the first item by default
      console.log("this.templateName", this.templateName);

    }
    this.getPatientsVisitInfo();
    this.patientFullName = this.patientResponse.firstName + " " + this.patientResponse.lastName;
    const years = this.patientResponse.age.years ? this.patientResponse.age.years + 'Y ' : '';
    const months = this.patientResponse.age.months ? this.patientResponse.age.months + 'M ' : '';

    this.patientAge = years + months;
    this.getAllReferrals();

  }
  openDialog(content: any) {
    this.dialog.open(content);
  }
  closeDialog() {

    this.dialog.closeAll();
  }
  switchDaysWeeks(index: any) {
    let array = this.dayWeeksArray;
    array.map((ins: any, ind: any) => {
      if (ind == index) {
        array[index].selected = true;

        this.selectedWhenToTake = ins.name;
        if (this.selectedWhenToTake == 'Days') {
          this.daysWeeks = 'Days'
        }
        else if (this.selectedWhenToTake == 'Weeks') {
          this.daysWeeks = 'Weeks'
        }
        else {
          this.daysWeeks = 'Month'
        }

        // this.daysWeeks='Weeks'
      } else {
        ins.selected = false;
        //this.daysWeeks='weeks'
        // this.daysWeeks='Weeks'
      }

    });

  }

  editRefferal() {
    this.openDialog(this.addReferralModal);
  }
  replaceValuee(e: any) {
    this.presentComplaints = e;
    this.medCondition = this.presentComplaints
  }
  replaceValue(e: any) {

    this.duration = e;



    this.durationnn = this.duration


  }
  onDropdownSelectTemplate = (item: any) => {
    this.templateName = item
    console.log("this.templateName", item);

  }
  getPatientsVisitInfo() {
    const patientID = this.pramPatientId;

    this.patientService.getPatientsVisitInfo(patientID).subscribe((response: any) => {
      console.log("response chief complaints", response[0]?.data?.[0]);

      if (response && response[0]?.data?.[0]) {
        const visit = response[0].data[0];
        const chiefComplaints = visit.chief_complaints || '';
        const visitDate = visit.date ? moment(visit.date).format('YYYY-MM-DD') : null;
        const today = moment().format('YYYY-MM-DD');

        // ✅ Compare dates
        if (visitDate === today) {
          // same day → keep complaints
          this.replaceValuee(chiefComplaints);
        } else {
          // different day → clear complaints
          this.presentComplaints = '';
        }

        console.log("presentComplaints", this.presentComplaints);
      } else {
        // No visit data → clear by default
        this.presentComplaints = '';
      }
    });
  }

  closeReferral() {
    this.docNamee = "";
    this.docEmail = "";
    this.duration = "";
    this.presentComplaints = this.presentComplaints;
    this.docMobNumber = "";
    this.selectedWhenToTake = " ";

    this.medCondition = this.presentComplaints;
    this.durationnn = "";

    var refeeral: any = document.getElementById('refeeral')?.textContent;

    refeeral = " "
    // this.dayWeeksArray.map(ins=>ins.selected=false)
  }


  getAllReferrals() {
    this.allReferrals = [];

    if (!this.appointmentArr) return;
    console.log("appointmentArr", this.appointmentArr);

    this.appointmentArr.forEach((element: any) => {

      if (element.Certificates) {
        let certificates = JSON.parse(element.Certificates);

        certificates.forEach((ins: any) => {

          if (ins.type === "Referal Note" && ins.url) {

            this.allReferrals.push({
              documentDate: element.createdAt,
              documentType: "Referral",
              uploadedBy: element.Doctor?.User?.first_name + " " + element.Doctor?.User?.last_name,
              url: ins.url,
              docMobNumber: ins.docNo,
            });
            console.log("✅ Referral Table Data 1234", this.allReferrals);
          }

        });
      }

    });

    // sort latest first
    this.allReferrals.sort((a: any, b: any) => {
      return new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime();
    });
    const today = moment().format('YYYY-MM-DD');

    this.alreadyCreated = this.allReferrals?.some((item: any) => {
      return moment(item.documentDate).format('YYYY-MM-DD') === today;
    });

    // this.allReferrals = new MatTableDataSource(this.allReferrals);

    console.log("✅ Referral Table Data", this.allReferrals);
  }
  createReferral() {


    this.openDialog(this.addReferralModal);
    setTimeout(() => {
      this.closeReferral();
    }
      , 100);


  }
  printNewRefreel(action: any, form?: any) {

    this.showErrors = true;

    if (form) {
      form.control.markAllAsTouched();

      if (form.invalid) {
        this.messageService.add({
          severity: 'warn',
          detail: 'Please fill all required fields'
        });
        return;
      }
    }

    // ✅ Continue API logic
    this.isReferralLoading = true;
    // 🧩 Step 1: Validate input fields
    if (!this.docNamee?.trim()) {
      this.isReferralLoading = false;
      this.messageService.add({ severity: 'custom', detail: 'Please enter referring doctor name' });
      return;
    }

    if (this.templateName === 'Speciality') {
      this.isReferralLoading = false;
      this.messageService.add({ severity: 'custom', detail: 'Please specify speciality before proceeding' });
      return;
    }
    this.isReferralLoading = true;
    // 🧩 Step 2: Get and clean the referral text
    const referralEl = document.getElementById('refeeral');

    if (referralEl) {
      this.templateText = referralEl.innerText
        .replace(/\n+/g, '\n')        // normalize multiple new lines
        .replace(/\n/g, '<br>')      // convert to HTML line breaks
        .trim();
    }

    // 🧩 Step 3: Check if today's referral already exists (no API call if so)
    const today = moment().format('YYYY-MM-DD');

    const existingReferral = this.appointmentArr?.some((appt: any) => {

      const apptDate = moment(appt.createdAt).format('YYYY-MM-DD');
      if (apptDate !== today || !appt.Certificates) return false;

      let certificates = [];
      try {
        certificates = JSON.parse(appt.Certificates);
      } catch {
        return false;
      }

      return certificates.some((cert: any) =>
        cert.type === "Referal Note" &&
        cert.docNo === this.docMobNumber   // ✅ MATCH MOBILE NUMBER
      );

    });
    if (existingReferral) {
      this.isReferralLoading = false;

      this.messageService.add({
        severity: 'custom',
        detail: 'Referral already created today for this doctor.'
      });

      this.closeDialog();
      this.callParentFunction();

      this.refreshservice.OnPatTopNav_MenuSelected(
        this.patientResponse.id ? this.patientResponse.id : this.patientResponse._id + '',
        this.refreshservice.EventName_Referral
      );

      return; // ⛔ STOP API
    }

    // 🧩 Step 4: Prepare postData for API
    const postData: any = {
      patient_id: this.patientResponse.id || this.pramPatientId,
      action: action === 'share' ? 'share' : action,
      date: moment(this.parseDate(this.selectedDate)).format('YYYY-MM-DD'),
      type: 'Referal Note',
      title: 'ADVICE SOLICITED',
      text: this.templateText,
      docName: this.docNamee,
      docNo: this.docMobNumber,
      docEmail: this.docEmail,
      templateName: this.templateName
    };
    this.isReferralLoading = false
    // 🧩 Step 5: Attach today’s appointmentId (if exists)
    const todaysAppt = this.appointmentArr?.find(
      (appt: any) => moment(appt.createdAt).format('YYYY-MM-DD') === today
    );
    if (todaysAppt) {
      postData.appointmentId = todaysAppt.id;
    }

    console.log('📤 Final PostData for printCertificate:', postData);

    // 🧩 Step 6: Call API
    this.patientService.printCertificate(postData).subscribe({
      next: async (response: any) => {
        if (response) {
          console.log('✅ API Response:', response);
          this.getAllReferrals();
          this.modalService.dismissAll();
          this.refreelcertiPdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(response.url);
          this.refreelcertisURL = response.url;

          if (action === 'preview') {
            setTimeout(() => {
              setTimeout(() => {
                const sidenavWidth =
                  document.querySelector('.mat-sidenav')?.clientWidth || 175;

                document.documentElement.style.setProperty(
                  '--sidenav-width',
                  `${sidenavWidth}px`
                );

                this.dialog.open(this.viewReferralModal, {
                  panelClass: 'full-screen-modal',
                  backdropClass: 'no-padding-backdrop',
                  autoFocus: false,
                  hasBackdrop: true
                });

                this.isReferralLoading = false;
              }, 50);
              this.isReferralLoading = false;
            }, 50);
          } else if (action === 'share') {
            this.isReferralLoading = false;
            this.messageService.add({
              severity: 'custom',
              detail: 'Certificate saved and shared with patient successfully'
            });
            this.callParentFunction();
            this.refreshservice.OnPatTopNav_MenuSelected(
              this.patientResponse.id ? this.patientResponse.id : this.patientResponse._id + '',
              this.refreshservice.EventName_Referral
            );
            this.getAllReferrals();
          }
        }
      },
      error: (err: any) => {
        console.error('❌ printCertificate API error:', err);
        this.isReferralLoading = false;
        this.messageService.add({
          severity: 'error',
          detail: 'Error creating referral. Please try again later.'
        });
      }
    });
  }

  onlyAlphabets(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode);

    // Allow letters + space
    if (!/^[a-zA-Z\s]*$/.test(char)) {
      event.preventDefault();
    }
  }
  onlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(event.key)) return;

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  shareOnWhatsApp() {
    if (!this.refreelcertisURL) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please generate referral first'
      });
      return;
    }

    const message = `Referral for patient:\n${this.refreelcertisURL}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, '_blank');
  }


  reverseDate(date: any) {
    let d = new Date(date);
    return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
  }
  parseDate(dateObject: any) {
    var date = new Date();
    date.setDate(dateObject.day);
    date.setMonth(dateObject.month - 1);
    date.setFullYear(dateObject.year);
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }
  validateNumber(e: any) {
    return (
      (e.charCode > 47 && e.charCode < 58) ||
      e.charCode == 46 ||
      e.which == 8 ||
      e.which == 13 ||
      e.keyCode == 9
    );
  }
  onClickViewRert(referral: any) {
    if (!referral?.url) return;

    this.documentPdfURL =
      this.sanitizer.bypassSecurityTrustResourceUrl(referral.url);

    setTimeout(() => {
      const sidenavWidth =
        document.querySelector('.mat-sidenav')?.clientWidth || 175;

      document.documentElement.style.setProperty(
        '--sidenav-width',
        `${sidenavWidth}px`
      );

      this.dialog.open(this.viewDocumentsModal, {
        panelClass: 'full-screen-modal',   // ✅ SAME CLASS
        backdropClass: 'no-padding-backdrop',
        autoFocus: false
      });
    }, 50);
  }
}